import VideosTable from "components/Admin/Tables/VideosTable";
import React, { memo } from "react";
import Widget from "../Widget";

interface Props {}

const VideosWidget: React.FC<Props> = () => {
  return (
    <Widget title="Видеа">
      <VideosTable />
    </Widget>
  );
};

export default memo(VideosWidget);
